import { Component, Input } from '@angular/core';

export interface Sum {
  subTotal: string,
  total: string,
  vat: string,
  delivery: string,
  discount?: string,
  subTotalWithDiscounts?: string
}

@Component({
  selector: 'kion-basket-summary',
  templateUrl: './basket-summary.component.html',
  styleUrls: ['./basket-summary.component.scss']
})
export class BasketSummaryComponent {
  @Input() price: Sum;
}
